import type {
  PricePeriodType,
  PriceUnitType
} from '@elfsight/configurator-contracts';
import { useLingui } from '@lingui/react/macro';

type Postfix = PriceUnitType | PricePeriodType;

export const usePriceTranslatedPostfix = (postfix: Postfix) => {
  const { t } = useLingui();
  const translations: Record<Postfix, string> = {
    day: t`day`,
    gal: t`gal`,
    GB: t({ message: 'GB', context: 'Price per unit' }),
    hour: t`hour`,
    item: t({ message: 'item', context: 'Price per unit' }),
    kg: t`kg`,
    liter: t`liter`,
    m: t`m`,
    mile: t`mile`,
    month: t`month`,
    oz: t`oz`,
    lb: t`lb`,
    'ft²': t`ft²`,
    'm²': t`m²`,
    week: t`week`,
    year: t`year`,
    quarter: t`quarter`,
    '6 months': t`6 months`
  };

  return translations[postfix];
};
